/**
 * Waits for element to load on to page
 * @param  {Node} el Selector for the desired element to wrap
 * @example waitForEl('.class_selector').then((elm) => { ... });
 * 
 */
const waitForEl = (selector) => {
return new Promise(resolve => {
    if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
}       